import type { Localized } from '../../types/blog'

export const BLOG_DATE_PUBLISHED = '2026-02-01'
export const BLOG_DATE_MODIFIED = '2026-09-28'

export const publishedLabel: Localized = {
  en: 'Published: February 2026',
  ua: 'Опубліковано: лютий 2026',
  ru: 'Опубликовано: февраль 2026',
  ro: 'Publicat: februarie 2026',
}

export const updatedLabel: Localized = {
  en: 'Updated: September 2026',
  ua: 'Оновлено: вересень 2026',
  ru: 'Обновлено: сентябрь 2026',
  ro: 'Actualizat: septembrie 2026',
}

export const blogUi = {
  back: {
    en: 'Back to blog',
    ua: 'Назад до блогу',
    ru: 'Назад в блог',
    ro: 'Înapoi la blog',
  },
  author: {
    en: 'Dentico Clinic Team',
    ua: 'Команда Dentico Clinic',
    ru: 'Команда Dentico Clinic',
    ro: 'Echipa Dentico Clinic',
  },
  expert: {
    en: 'Expert Article',
    ua: 'Експертна стаття',
    ru: 'Экспертная статья',
    ro: 'Articol Expert',
  },
  faqTitle: {
    en: 'Frequently Asked Questions',
    ua: 'Часті запитання',
    ru: 'Частые вопросы',
    ro: 'Întrebări frecvente',
  },
  readAlso: {
    en: 'Read Also',
    ua: 'Читайте також',
    ru: 'Читайте также',
    ro: 'Citește și',
  },
  disclaimer: {
    en: 'This information is general guidance and does not replace a clinical examination by a dentist.',
    ua: 'Ця інформація має загальний характер і не замінює клінічного огляду стоматолога.',
    ru: 'Эта информация носит общий характер и не заменяет клинического осмотра стоматолога.',
    ro: 'Aceste informații au caracter general și nu înlocuiesc o examinare clinică efectuată de un medic stomatolog.',
  },
  ctaTitle: {
    en: 'Need dental advice in Angel, London?',
    ua: 'Потрібна консультація стоматолога в Лондоні?',
    ru: 'Нужна консультация стоматолога в Лондоне?',
    ro: 'Aveți nevoie de o consultație stomatologică în Londra?',
  },
  ctaText: {
    en: 'Book a consultation at Dentico Clinic or send us a message on WhatsApp.',
    ua: 'Запишіться на консультацію в Dentico Clinic або напишіть нам у WhatsApp.',
    ru: 'Запишитесь на консультацию в Dentico Clinic или напишите нам в WhatsApp.',
    ro: 'Programați o consultație la Dentico Clinic sau trimiteți-ne un mesaj pe WhatsApp.',
  },
  bookOnline: {
    en: 'Book Online',
    ua: 'Записатися онлайн',
    ru: 'Записаться онлайн',
    ro: 'Programează online',
  },
  viewPrices: {
    en: 'View Prices',
    ua: 'Переглянути ціни',
    ru: 'Посмотреть цены',
    ro: 'Vezi prețurile',
  },
  requestCall: {
    en: 'Request a Call',
    ua: 'Замовити дзвінок',
    ru: 'Заказать звонок',
    ro: 'Solicitați un apel',
  },
  callClinic: {
    en: 'Call Clinic',
    ua: 'Зателефонувати',
    ru: 'Позвонить',
    ro: 'Sunați clinica',
  },
  read: { en: 'Read', ua: 'Читати', ru: 'Читать', ro: 'Citește' },
}
